import type { CSSProperties } from 'react';
import { useTheme } from '@emotion/react';

export const GradientsProvider = () => {
  const theme = useTheme();

  return (
    <div style={{ width: 0, height: 0, overflow: 'hidden' }}>
      <svg width={0} height={0} version="1.1" xmlns="http://www.w3.org/2000/svg">
        <defs>
          <linearGradient id="gradient-one">
            <stop style={{ stopColor: theme.color.primary[100] } as CSSProperties} offset="0%"></stop>
            <stop style={{ stopColor: theme.color.secondary[100] } as CSSProperties} offset="100%"></stop>
          </linearGradient>
          <linearGradient id="gradient-two" x1="0" x2="1" y1="0" y2="1">
            <stop style={{ stopColor: theme.color.primary[100] } as CSSProperties} offset="0%"></stop>
            <stop style={{ stopColor: theme.color.secondary[100] } as CSSProperties} offset="100%"></stop>
          </linearGradient>
          <linearGradient id="gradient-three" x1="0" x2="0" y1="0" y2="1">
            <stop style={{ stopColor: theme.color.primary[100] } as CSSProperties} offset="0%"></stop>
            <stop style={{ stopColor: theme.color.secondary[100] } as CSSProperties} offset="100%"></stop>
          </linearGradient>
        </defs>
      </svg>
    </div>
  );
};
